<div class="layout-topbar">
   <div class="flex gap-2">
      <button #menubutton type="button" class="topbar-menubutton p-link p-trigger mr-2" (click)="onMenuButtonClick()">
         <lucide-icon name="chevron-right" [size]="16"></lucide-icon>
      </button>
      <p-menubar [model]="itemsStart" [autoDisplay]="false" [autoHide]="true"> </p-menubar>
   </div>

   <div class="topbar-end flex gap-3 align-items-center pr-4">
      <pay-chip
         [label]="selectedTimezone"
         variant="navy"
         style="cursor: pointer"
         (click)="showTimezone()"
         [ngStyle]="{ cursor: 'pointer' }"
      ></pay-chip>
      <p-button
         *ngIf="isAllow([PERMISSION_TYPE.FULL_ACCESS])"
         [label]="'DATA.COMMON.ASK' | translate"
         [ariaLabel]="'DATA.COMMON.ASK' | translate"
         severity="secondary"
         text="true"
         [styleClass]="(widgetOpen$ | async) ? 'text-only ask-active' : 'text-only'"
         (onClick)="toggleAskWidget()"
      >
         <ng-template pTemplate="icon" let-class="class">
            <ng-container *ngIf="widgetOpen$ | async; else chatIcon">
               <svg
                  class="{{ class }} elevenlabs-ask__icon elevenlabs-ask__icon--close mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                  focusable="false"
               >
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
               </svg>
            </ng-container>
            <ng-template #chatIcon>
               <svg
                  class="{{ class }} elevenlabs-ask__icon mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                  focusable="false"
               >
                  <path
                     d="M12.7 3H4a2 2 0 0 0-2 2v16.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H20a2 2 0 0 0 2-2v-4.7"
                  />
                  <circle cx="19" cy="6" r="3" />
               </svg>
            </ng-template>
         </ng-template>
      </p-button>
      <app-credit-badge *ngIf="isAllow([PERMISSION_TYPE.FULL_ACCESS])" />
      <p-divider layout="vertical" [style]="{ height: '5px' }" />
      <p-button
         *ngIf="isAllow([PERMISSION_TYPE.FULL_ACCESS])"
         [icon]="loading ? 'pi pi-spin pi-spinner' : 'pi pi-server'"
         [routerLink]="['/tenants']"
         [queryParamsHandling]="'preserve'"
         [pTooltip]="!loading ? tenantName : ''"
         [tooltipPosition]="'bottom'"
         [label]="loading ? 'Cargando...' : (tenantName | ellipsis: 8)"
         severity="secondary"
         text="true"
         styleClass="text-only"
      ></p-button>

      <ng-container *ngIf="!isAllow([PERMISSION_TYPE.FULL_ACCESS]) && hasMultipleTenants">
         <button class="topbar-tenant-link" (click)="tenantOverlay.toggle($event)">
            <lucide-icon name="building-2" [size]="14"></lucide-icon>
            {{ loading ? '...' : tenantName || currentTenantId }}
            <lucide-icon name="chevron-down" [size]="12"></lucide-icon>
         </button>
         <p-overlayPanel #tenantOverlay styleClass="tenant-switcher-panel">
            <div class="tenant-switcher__list">
               <button
                  *ngFor="let t of tenantOptions"
                  class="tenant-switcher__item"
                  [class.tenant-switcher__item--active]="t.id === currentTenantId"
                  (click)="switchTenant(t.id); tenantOverlay.hide()"
               >
                  {{ t.name }}
               </button>
            </div>
         </p-overlayPanel>
      </ng-container>

      <button type="button" class="p-link m-2" (click)="onProfileButtonClick()">
         <p-avatar
            [label]="letters(user.name)"
            styleClass="w-2rem h-2rem border-circle"
            size="normal"
            [style]="{ 'background-color': '#c1cdd7', color: 'black' }"
            shape="circle"
         ></p-avatar>
      </button>
   </div>
</div>
